// extracted by mini-css-extract-plugin
export default {"confirmTitle":"confirmModal-module--confirm-title--gV1mI","confirmBtn":"confirmModal-module--confirm-btn--CqSyg"};